// @flow
import React, { Component } from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import FileReaderInput from 'react-file-reader-input';
import FontAwesome from 'react-fontawesome';

import TextInput from './components/TextInput/TextInput';
import ContactInput from './components/ContactInput/ContactInput';
import SliderInput from './components/SliderInput/SliderInput';

const imageTitleStyle = {
  textAlign: 'right',
};

const colStyle = {
  marginBottom: '10px',
}

class BrandedPage extends Component<{
  user: Object,
}, {
  feeds: Array<string>,
}> {

  constructor(props: Object) {
    super(props);
    const settings = this.props.user.modules.brandedPage;

    this.state = {
      general: {
        logo: (settings) ? settings.general.logo : '',
        background: (settings) ? settings.general.background : '',
        backgroundOpacity: (settings) ? settings.general.backgroundOpacity : 100,
      },
      calendar: {
        name: (settings) ? settings.calendar.name : '',
        calendars: (settings) ? settings.calendar.calendars : ['', ''],
      },
      news: {
        name: (settings) ? settings.news.name : '',
        feeds: (settings) ? settings.news.feeds : ['', ''],
      },
      calling: {
        contacts: (settings) ? settings.calling.contacts : ['', ''],
      },
    };
  }

  save(user: Object): Object {
    const newUser = user;
    newUser.modules.brandedPage = this.state;
    return newUser;
  }

  handleLogoChange(results: any) {
    const size = results[0].total / 1024;
    if (size <= 500) {
      const picture = results[0].target.result;

      const general = this.state.general;
      general.logo = picture;
      this.setState({ general });
    }
  }

  removeLogo() {
    const general = this.state.general;
    general.logo = '';
    this.setState({ general });
  }

  handleBackgroundChange(results: any) {
    const size = results[0].total / 1024;
    if (size <= 500) {
      const picture = results[0].target.result;

      const general = this.state.general;
      general.background = picture;
      this.setState({ general });
    }
  }

  removeBackground() {
    const general = this.state.general;
    general.background = '';
    this.setState({ general });
  }

  render() {
    return (<div>

      <Form horizontal>
        <h4>General</h4>

        <Row>
          <Col sm={3} style={imageTitleStyle}>
            <h5><b>Logo</b></h5>
          </Col>
          <Col sm={2} style={colStyle}>
            { this.state.general.logo ? <img src={this.state.general.logo} alt="" style={{ width: '60px' }} /> : <FontAwesome name="fa-picture-o" size="2x" /> }
          </Col>
          <Col sm={2} style={colStyle}>
            <FileReaderInput
              as="url"
              id="img-input"
              accept=".png,.gif,.jpg"
              onChange={(evt, res) => this.handleLogoChange(res[0])}
              multiple="false"
            >
              <Button>Change</Button>
            </FileReaderInput>
          </Col>
          <Col sm={1} style={colStyle}>
            <Button onClick={() => this.removeLogo()}><FontAwesome name="trash" /></Button>
          </Col>
        </Row>

        <Row>
          <Col sm={3} style={imageTitleStyle}>
            <h5><b>Background</b></h5>
          </Col>
          <Col sm={2} style={colStyle}>
            { this.state.general.background ? <img src={this.state.general.background} alt="" style={{ width: '60px' }} /> : <FontAwesome name="fa-picture-o" size="2x" /> }
          </Col>
          <Col sm={2} style={colStyle}>
            <FileReaderInput
              as="url"
              id="img-input"
              accept=".png,.gif,.jpg"
              onChange={(evt, res) => this.handleBackgroundChange(res[0])}
              multiple="false"
            >
              <Button>Change</Button>
            </FileReaderInput>
          </Col>
          <Col sm={1} style={colStyle}>
            <Button onClick={() => this.removeBackground()}><FontAwesome name="trash" /></Button>
          </Col>
        </Row>

        <SliderInput
          title="Opacity"
          min={0}
          max={100}
          step={1}
          defaultValue={this.state.general.backgroundOpacity}
          onChange={(e) => {
            const general = this.state.general;
            general.backgroundOpacity = e;
            this.setState({ general });
          }}
        />

        <h4>Calendar</h4>
        <TextInput
          title="Name"
          defaultValue={this.state.calendar.name}
          onChange={(e) => {
            const calendar = this.state.calendar;
            calendar.name = e;
            this.setState({ calendar });
          }}
        />
        <TextInput
          title="Public calendar ID 1"
          defaultValue={this.state.calendar.calendars[0]}
          onChange={(e) => {
            const calendar = this.state.calendar;
            calendar.calendars[0] = e;
            this.setState({ calendar });
          }}
        />
        <TextInput
          title="Public calendar ID 2"
          defaultValue={this.state.calendar.calendars[1]}
          onChange={(e) => {
            const calendar = this.state.calendar;
            calendar.calendars[1] = e;
            this.setState({ calendar });
          }}
        />
        <h4>News</h4>
        <TextInput
          title="Name"
          defaultValue={this.state.news.name}
          onChange={(e) => {
            const news = this.state.news;
            news.name = e;
            this.setState({ news });
          }}
        />
        <TextInput
          title="Feed 1"
          defaultValue={this.state.news.feeds[0]}
          onChange={(e) => {
            const news = this.state.news;
            news.feeds[0] = e;
            this.setState({ news });
          }}
        />
        <TextInput
          title="Feed 2"
          defaultValue={this.state.news.feeds[1]}
          onChange={(e) => {
            const news = this.state.news;
            news.feeds[1] = e;
            this.setState({ news });
          }}
        />
        <h4>Calling</h4>
        <ContactInput
          title="Person 1"
          list={(this.props.user.modules.calling.contacts) ? this.props.user.modules.calling.contacts.map(e => e.name) : []}
          defaultValue={this.state.calling.contacts[0]}
          onChange={(e) => {
            const calling = this.state.calling;
            calling.contacts[0] = e;
            this.setState({ calling });
          }}
        />
        <ContactInput
          title="Person 2"
          list={(this.props.user.modules.calling.contacts) ? this.props.user.modules.calling.contacts.map(e => e.name) : []}
          defaultValue={this.state.calling.contacts[1]}
          onChange={(e) => {
            const calling = this.state.calling;
            calling.contacts[1] = e;
            this.setState({ calling });
          }}
        />
      </Form>
    </div>);
  }
}

export default BrandedPage;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/BrandedPage/BrandedPage.js